import React, { FC } from 'react';

import SignContract from '~/components/views/contract';

const SignContractPage: FC = () => {
  return <SignContract />;
};

export default SignContractPage;
